(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_subscription-chooser"] && !Shopify.designMode) return;
  try {
    // === 1. Hide "days" delivery frequencies (bundle-only from Loop) ===
function hideDaysFrequencies() {
    if (window.location.pathname.includes("bundle")) return;    document.querySelectorAll(".subscription-chooser__frequency-select").forEach(function(select) {
      Array.from(select.options).forEach(function(option) {
        if (option.text.toLowerCase().includes("day")) option.remove();
      });
    });
  }

  // === 2. Show "with Free Shipping" only when subscription is on ===
  function updateShippingSuffix() {
    var toggles = document.querySelectorAll(".subscription-chooser__toggle-checkbox");
    var suffixes = document.querySelectorAll(".estimated-delivery__suffix");
    toggles.forEach(function(toggle) {
      suffixes.forEach(function(suffix) { suffix.style.display = toggle.checked ? "" : "none"; });
    });
    if (toggles.length === 0) suffixes.forEach(function(s) { s.style.display = "none"; });
  }

  // === 3. Add "(recommended)" to frequency matching dog size ===
  function updateRecommendedFrequency() {
    var active = document.querySelector(".subscription-chooser__dog-size--active") || document.querySelector(".subscription-chooser__dog-size input:checked");
    if (!active) return;
    var label = active.closest(".subscription-chooser__dog-size") || active;
    var pouchQty = label.dataset.pouchQuantity;
    var select = document.querySelector(".subscription-chooser__frequency-select");
    if (!select) return;
    Array.from(select.options).forEach(function(opt) {
      var clean = opt.text.replace(/\s*\(recommended\)/i, "");
      opt.text = (opt.dataset.pouchQuantity === pouchQty && pouchQty !== "") ? clean + " (recommended)" : clean;
    });
  }

  // === 4. Strikethrough RRP + shipping on ATC button (subscription only) ===
  var SHIPPING_COST = 299;
  var FREE_SHIPPING_THRESHOLD = 4000;
  var _productCache = null;
  function getProductData() {
    if (_productCache) return Promise.resolve(_productCache);
    return fetch(window.location.pathname.split("?")[0] + ".js")
      .then(function(r) { return r.json(); })
      .then(function(d) { _productCache = d; return d; });
  }
  function updateATCPricing() {
    var toggle = document.querySelector(".subscription-chooser__toggle-checkbox");
    var atcContent = document.querySelector(".add-to-cart-text__content");
    if (!atcContent) return;
    var existing = atcContent.querySelector(".atc-price-display");
    if (existing) existing.remove();
    if (!toggle || !toggle.checked) return;
    var variantInput = document.querySelector('input[name="id"]');
    var spSelect = document.querySelector(".subscription-chooser__frequency-select");
    if (!variantInput || !spSelect) return;
    var vid = parseInt(variantInput.value);
    var spid = parseInt(spSelect.value);
    getProductData().then(function(product) {
      var variant = product.variants.find(function(v) { return v.id === vid; });
      if (!variant) return;
      var rrp = variant.price;
      var shipping = rrp < FREE_SHIPPING_THRESHOLD ? SHIPPING_COST : 0;
      var rrpTotal = rrp + shipping;
      var alloc = (variant.selling_plan_allocations || []).find(function(a) { return a.selling_plan_id === spid; });
      var subPrice = alloc ? alloc.price : rrp;
      var span = document.createElement("span");
      span.className = "atc-price-display";
      span.innerHTML = ' - <s style="opacity:0.6;font-weight:400">\u00a3' + (rrpTotal / 100).toFixed(2) + '</s> \u00a3' + (subPrice / 100).toFixed(2);
      var old = atcContent.querySelector(".atc-price-display");
      if (old) old.remove();
      atcContent.appendChild(span);
    });
  }

  // === Initialise with retry (waits for DOM elements to be ready) ===
  (function initWithRetry() {
    var atc = document.querySelector(".add-to-cart-text__content");
    var freq = document.querySelector(".subscription-chooser__frequency-select");
    if (atc && freq) {
      hideDaysFrequencies();
      updateShippingSuffix();
      updateRecommendedFrequency();
      updateATCPricing();
    } else {
      setTimeout(initWithRetry, 300);
    }
  })();

  // === Event listeners ===
  document.addEventListener("change", function(e) {
    if (e.target.classList.contains("subscription-chooser__toggle-checkbox")) {
      updateShippingSuffix();
      setTimeout(updateATCPricing, 100);
    }
    if (e.target.classList.contains("subscription-chooser__frequency-select")) {
      setTimeout(updateATCPricing, 100);
    }
    if (e.target.name && e.target.name.startsWith("dog-size")) {
      setTimeout(updateRecommendedFrequency, 0);
      setTimeout(updateATCPricing, 300);
    }
  });
  document.addEventListener("click", function(e) {
    if (e.target.closest(".subscription-chooser__dog-size")) {
      setTimeout(updateRecommendedFrequency, 0);
      setTimeout(updateATCPricing, 300);
    }
    if (e.target.closest(".subscription-chooser__quantity-option")) {
      setTimeout(updateATCPricing, 200);
    }
  });
  var freqObs = new MutationObserver(hideDaysFrequencies);
  document.querySelectorAll(".subscription-chooser__frequency").forEach(function(el) {
    freqObs.observe(el, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

})();
